import type { Device } from '@cdc-internal/fe-toolbox/utils/device'
import type { userAgent } from 'next/server'

export interface AmountCurrencyPair {
  amount: string
  currency: string
}

// Browsers identify a cookie by name, domain, and path.
export type CookieScopeAttributes = 'name' | 'domain' | 'path'

export type RequestUserAgent = ReturnType<typeof userAgent> & {
  device: {
    kind: Device
  }
}

export type SortDirection = 'asc' | 'desc'

export type LoadingStatus = 'loading' | 'finished' | 'error' | 'pending'

export interface ToggleHandlers {
  open: () => void
  close: () => void
  toggle: () => void
}

export enum CurrencyType {
  Crypto = 'crypto',
  Fiat = 'fiat',
}

export type Currency<T = string, F = string> = {
  code: T
  name: string
  symbol: F
  dollarPrefix?: string
  iconUrl: string
  type: CurrencyType
  nameKey?: string
}
